module.exports = __webpack_public_path__ + "img/background043.jpg";